@if (visible$ | async) {
    <fieldset [formGroup]="standardFunctionalElementGroup">
        <ng-container *ngrxLet="standardFunctionalElement$; let standardFunctionalElement">
            <div class="row">
                <p class="col-sm-10 col-12" [innerHTML]="standardFunctionalElement.label"></p>
                <span class="col-sm-2 col-12 text-end filter-text">{{ elementTypeLabel$ | async }}</span>
            </div>
            <div class="row">
                <div class="col">
                    @if (standardFunctionalElement.choices) {
                        <pace-forms-choices
                            [choices]="choices$ | async"
                            [formControl]="radioControl"
                        ></pace-forms-choices>
                    }
                </div>
                @if (displayHistoryButton$ | async) {
                    <div class="col-auto d-flex align-items-center">
                        <pace-forms-history-button
                            [uniqueId]="standardFunctionalElement.uniqueId"
                        ></pace-forms-history-button>
                    </div>
                }
            </div>
            @if (showRemarksField$ | async) {
                <pace-forms-input-text
                    [id]="standardFunctionalElement.xmlId"
                    [label]="standardFunctionalElement.remarksLabel"
                    [formControl]="remarksControl"
                ></pace-forms-input-text>
            }
        </ng-container>
    </fieldset>
}
